import React from 'react';

import './CardContainer.css';

const CardContainer = ({ title, color = '#559ab3', children }) => {
    return (
        <div className="card-container">
            <div className="card-header" style={{ backgroundColor: color }}>
                {title}
            </div>
            <div className="card--content">{children}</div>
        </div>
    );
};

export default CardContainer;
